import React from 'react';
import { SidebarSection } from '../components/Sidebar';
import { NavIcon } from '../components/icons/NavIcon';
import { Role } from '../types/app';

export const fleetSidebarSections: SidebarSection[] = [
  {
    label: 'Operations',
    items: [
      { id: '/fleet/dashboard', label: 'Dashboard', icon: <NavIcon type="home" /> },
      { id: '/fleet/map', label: 'Live map', icon: <NavIcon type="map" /> },
      { id: '/fleet/assignments', label: 'Assignments', icon: <NavIcon type="calendar" /> },
    ],
  },
  {
    label: 'Resources',
    items: [
      { id: '/fleet/drivers', label: 'Drivers', icon: <NavIcon type="user" /> },
      { id: '/fleet/vehicles', label: 'Vehicles', icon: <NavIcon type="truck" /> },
      { id: '/fleet/authority', label: 'Fleet organization', icon: <NavIcon type="nodes" /> },
    ],
  },
];

export const adminSidebarSections: SidebarSection[] = [
  {
    label: 'Overview',
    items: [
      { id: '/admin/overview', label: 'Dashboard', icon: <NavIcon type="home" /> },
      { id: '/admin/kyc', label: 'KYC queue', icon: <NavIcon type="shield" /> },
    ],
  },
  {
    label: 'Users',
    items: [
      { id: '/admin/passengers', label: 'Passengers', icon: <NavIcon type="user" /> },
      { id: '/admin/fleet-managers', label: 'Fleet managers', icon: <NavIcon type="shield" /> },
      { id: '/fleet/drivers', label: 'Drivers', icon: <NavIcon type="truck" /> },
      { id: '/fleet/vehicles', label: 'Vehicles', icon: <NavIcon type="vehicle" /> },
    ],
  },
  {
    label: 'Finance',
    items: [
      { id: '/admin/transactions', label: 'Transactions', icon: <NavIcon type="card" /> },
      { id: '/admin/routes', label: 'Routes', icon: <NavIcon type="route" /> },
    ],
  },
];

export const superAdminOnlySidebarSections: SidebarSection[] = [
  {
    label: 'System',
    items: [
      { id: '/system/admin-invitations', label: 'Admin invitations', icon: <NavIcon type="user-add" /> },
      { id: '/system/admin-users', label: 'Admin users', icon: <NavIcon type="user" /> },
      { id: '/system/health', label: 'Health', icon: <NavIcon type="health" /> },
      { id: '/system/audit', label: 'Audit', icon: <NavIcon type="audit" /> },
    ],
  },
];

export const superAdminSidebarSections: SidebarSection[] = [
  ...adminSidebarSections,
  ...superAdminOnlySidebarSections,
];

export const accountSidebarSection: SidebarSection = {
  label: 'Account',
  items: [
    { id: '/account/profile', label: 'My profile', icon: <NavIcon type="user" /> },
  ],
};

export const lawSidebarSections: SidebarSection[] = [
  {
    label: 'Response',
    items: [
      { id: '/incidents', label: 'Active incidents', icon: <NavIcon type="alert" />, count: 2 },
      { id: '/incidents/all', label: 'All incidents', icon: <NavIcon type="audit" /> },
    ],
  },
  {
    label: 'Tools',
    items: [
      { id: '/incidents/map', label: 'Incident map', icon: <NavIcon type="map" /> },
    ],
  },
];

export function getSidebarSections(role: Role | '', kycPendingCount?: number) {
  const withLiveCounts = (sections: SidebarSection[]) => sections.map((section) => ({
    ...section,
    items: section.items.map((item) => item.id === '/admin/kyc'
      ? { ...item, count: kycPendingCount }
      : item),
  }));

  if (role === 'fleet_manager') {
    return [...fleetSidebarSections, accountSidebarSection];
  }

  if (role === 'super_admin') {
    return [...withLiveCounts(superAdminSidebarSections), accountSidebarSection];
  }

  if (role === 'admin') {
    return [...withLiveCounts(adminSidebarSections), accountSidebarSection];
  }

  if (role === 'law_enforcement') {
    return [...lawSidebarSections, accountSidebarSection];
  }

  return [];
}

export function getDefaultRoute(role: Role | '') {
  if (role === 'admin' || role === 'super_admin') {
    return '/admin/overview';
  }

  if (role === 'fleet_manager') {
    return '/fleet/dashboard';
  }

  if (role === 'law_enforcement') {
    return '/incidents';
  }

  return '/fleet/dashboard';
}
